var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"form_item",staticClass:"yd-form_item hl-form_item"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }